import type { ListItemType } from "./types";

export const getListItems = (reviewUrl: string): ListItemType[] => [
  {
    name: "Home",
    url: "/",
  },
  {
    name: "Avaliações",
    url: reviewUrl,
    blankPage: true,
  },
  {
    name: "Categorias",
    url: "/categorias",
  },
  {
    name: "Produtos",
    url: "/produtos",
  },
];
